import { render, staticRenderFns } from "./audit.vue?vue&type=template&id=18de1bcb&scoped=true"
import script from "./audit.vue?vue&type=script&lang=js"
export * from "./audit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18de1bcb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18de1bcb')) {
      api.createRecord('18de1bcb', component.options)
    } else {
      api.reload('18de1bcb', component.options)
    }
    module.hot.accept("./audit.vue?vue&type=template&id=18de1bcb&scoped=true", function () {
      api.rerender('18de1bcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/order/need_goods_simple/audit/audit.vue"
export default component.exports